/* eslint-disable @ngrx/avoid-dispatching-multiple-actions-sequentially */
/* eslint-disable @typescript-eslint/naming-convention */
import { DOCUMENT } from '@angular/common';
import {
	HttpClient,
	HttpContext,
	HttpEvent,
	HttpEventType,
	HttpHeaders,
	HttpRequest,
} from '@angular/common/http';
import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import firebase from 'firebase/compat/app';
import { catchError, last, map, tap } from 'rxjs/operators';
import { LearningService } from 'src/app/pages/app/learning/service/learning.service';
import { RudderStack } from 'src/app/services';
import { environment } from 'src/environments/environment';

import { BYPASS_LOG } from '../../pages/app/interceptor/interceptor.service';
import { AuthService } from '../../services/auth/auth.service';
import { AssignmentService } from './services/assignment.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-assignment-editor',
	templateUrl: './assignment-editor.component.html',
	styleUrls: ['./assignment-editor.component.scss'],
})
export class AssignmentEditorComponent implements OnInit, OnDestroy {
	@Input() public isCommentActive = false;
	@Input() public submissionId: any = '';
	@Input() public assignmentId = '';
	public cohortId: number;
	@Input() public readOnly: boolean;
	@Output() public reloadData = new EventEmitter<any>();
	@Output() public lastUpdated = new EventEmitter<any>();

	public localComments = {};
	@ViewChild('editor') public editor: any;

	public currentUser: any;
	public files: any[] = [];
	private isAutoSaveInProgress: boolean = false;
	private contentChanged$: Subject<void> = new Subject<void>();

	public tinycomments_create = (req, done, fail) => {
		const { content, createdAt } = req;

		if (this.editor.editor.selection.getContent()) {
			this.http
				.post<any>(
					`${environment.url.cohort}/assignment/submission/comment`,
					{
						content,
						name: this.currentUser.displayName,
						assignmentId: this.assignmentId,
						assignmentSubmissionId: this.submissionId,
					},
					{ context: new HttpContext().set(BYPASS_LOG, true) },
				)
				.toPromise()
				.then(req2 => {
					this.showMsg(req2);

					const conversationUid = req2.id;
					done({
						conversationUid,
					});
				})
				.catch(e => {
					fail();
				});
		} else {
			this.showMsg({
				error: 'error',
				message: 'Please select some text to add a comment',
			});
			fail();
		}
	};

	public tinycomments_reply = async (req, done, fail) => {
		const { conversationUid, content, createdAt } = req;

		const parent = this.localComments[conversationUid][0];

		await this.http
			.post<any>(
				`${environment.url.cohort}/assignment/submission/comment`,
				{
					content,
					name: this.currentUser.displayName,
					assignmentId: this.assignmentId,
					assignmentSubmissionId: this.submissionId,
					parentCommentId: Number(conversationUid),
					replyTo:
						parent.email !== this.currentUser.email ? parent.email : null,
					replyToName:
						parent.authorName !== this.currentUser.displayName
							? parent.authorName
							: null,
				},
				{ context: new HttpContext().set(BYPASS_LOG, true) },
			)
			.toPromise()
			.then(req2 => {
				this.showMsg(req2);

				const commentUid = req2.id;
				done({ commentUid });
			})
			.catch(e => {
				fail(e);
			});
	};

	public tinycomments_edit_comment = (req, done, fail) => {
		const { conversationUid, commentUid, content, modifiedAt } = req;

		this.http
			.put<any>(
				`${environment.url.cohort}/assignment/submission/comment/${commentUid}`,
				{ content, modifiedAt },
				{ context: new HttpContext().set(BYPASS_LOG, true) },
			)
			.toPromise()
			.then(response => {
				this.showMsg(response);

				if (response.count !== 0) {
					done({ canEdit: true });
				} else {
					done({ canEdit: false });
				}
			})
			.catch(e => {
				fail(e);
			});
	};

	public tinycomments_delete = (req, done, fail) => {
		const conversationUid = req.conversationUid;
		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/comment/${conversationUid}`,
				{ context: new HttpContext().set(BYPASS_LOG, true) },
			)
			.toPromise()
			.then(response => {
				this.showMsg(response);
				if (response.count !== 0) {
					done({ canDelete: true });
				} else {
					done({ canDelete: false });
				}
			});
	};

	public tinycomments_delete_all = (_req, done, fail) => {
		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/${this.submissionId}/comments`,
				{ context: new HttpContext().set(BYPASS_LOG, true) },
			)
			.toPromise()
			.then(response => {
				this.showMsg(response);
				if (response.count !== 0) {
					done({ canDelete: true });
				} else {
					done({ canDelete: false });
				}
			});
	};

	public tinycomments_delete_comment = (req, done, fail) => {
		const { conversationUid, commentUid } = req;
		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/comment/${commentUid}`,
				{ context: new HttpContext().set(BYPASS_LOG, true) },
			)
			.toPromise()
			.then(response => {
				if (response.count !== 0) {
					this.showMsg(response);
					done({ canDelete: true });
				} else {
					done({ canDelete: false });
				}
			});
	};

	public tinycomments_lookup = ({ conversationUid }, done, fail) => {
		const lookup = async () => {
			const comments: any = await this.http
				.get(
					`${environment.url.cohort}/assignment/submission/comment/${conversationUid}`,
					{ context: new HttpContext().set(BYPASS_LOG, true) },
				)
				.toPromise();

			const match = comments.data[0];

			const subReplay: any = [];

			match.replies
				.sort(
					(a: any, b: any) =>
						new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
				)
				.filter((r: any) => {
					if (Object.keys(r).length !== 0) {
						subReplay.push({
							...r,
							uid: r.id,
							content: r.content,
							authorName: r.name,
							author: r.name,
							authorAvatar: r.authorAvatar
								? r.authorAvatar
								: '/assets/default-img/profile.jpg',
							createdAt: new Date(r.updatedAt),
							modifiedAt: new Date(r.updatedAt),
						});
					}
				});
			return {
				conversation: {
					uid: conversationUid,
					comments: [
						{
							...match,
							uid: match.id,
							content: match.content,
							authorName: match.name,
							authorAvatar: match.authorAvatar
								? match.authorAvatar
								: '/assets/default-img/profile.jpg',
							author: match.name,
							createdAt: new Date(match.updatedAt),
							modifiedAt: new Date(match.updatedAt),
						},
						...subReplay,
					],
				},
			};
		};
		lookup()
			.then(data => {
				this.localComments[conversationUid] = data.conversation.comments;
				done(data);
			})
			.catch(err => {
				fail(err);
			});
	};

	public example_image_upload_handler = async (blobInfo, progress) => {
		const formData = new FormData();
		formData.append('file', blobInfo.blob(), blobInfo.filename());
		const token = await firebase.auth()?.currentUser?.getIdToken();

		const media: any = await this.http
			.post(`${environment.url.profile}/upload/assignments`, formData, {
				context: new HttpContext().set(BYPASS_LOG, true),
				headers: new HttpHeaders({
					Authorization: 'Bearer ' + token,
				}),
			})
			.toPromise();

		return media.url;
	};

	public init: any = false;

	public content;

	private commentReadMoreObserver?: MutationObserver;

	private commentReadMoreFrame?: number;

	private commentReadMoreTimer?: number;

	constructor(
		private assignmentService: AssignmentService,
		private http: HttpClient,
		private learningService: LearningService,
		private rudderStack: RudderStack,
		private authService: AuthService,
		@Inject(DOCUMENT) private document: Document,
	) {}

	public ngOnDestroy(): void {
		this.commentReadMoreObserver?.disconnect();
		const view = this.document.defaultView || window;
		if (this.commentReadMoreFrame != null) {
			view.cancelAnimationFrame(this.commentReadMoreFrame);
		}
		if (this.commentReadMoreTimer != null) {
			view.clearTimeout(this.commentReadMoreTimer);
		}
	}

	/**
	 * Patch annotator.getAll so Object.keys() returns conversation UIDs in
	 * document position order rather than numeric ascending order.
	 *
	 * TinyMCE builds $conversationUids via Object.keys(annotator.getAll("tinycomments")).
	 * Because UIDs are numeric database IDs (e.g. "1001"), ECMAScript's
	 * OrdinaryOwnPropertyKeys sorts integer-indexed keys numerically — meaning the
	 * sidebar always renders conversations in database-ID (creation-time) order.
	 *
	 * We return a Proxy whose ownKeys trap rescans the editor body with
	 * querySelectorAll (which always yields elements in document order) and returns
	 * UIDs in that order. The Proxy's [[OwnPropertyKeys]] delegates to the trap,
	 * bypassing the engine's integer-index re-sort, so Object.keys() receives UIDs
	 * in document position order.
	 */
	private installDocumentOrderAnnotator(editor: any): void {
		const ANNOTATION_NAME = 'tinycomments';
		const ANNOTATION_ATTR = 'data-mce-annotation';
		const UID_ATTR = 'data-mce-annotation-uid';

		const originalGetAll = editor.annotator.getAll.bind(editor.annotator);

		editor.annotator.getAll = (name: string) => {
			const result: any = originalGetAll(name);
			if (name !== ANNOTATION_NAME) {
				return result;
			}

			return new Proxy(result, {
				ownKeys: () => {
					const body: HTMLElement = editor.getBody();
					const seen = new Set<string>();
					const ordered: string[] = [];

					body
						.querySelectorAll(`[${ANNOTATION_ATTR}="${name}"]`)
						.forEach((el: Element) => {
							const uid = el.getAttribute(UID_ATTR);
							if (uid !== null && !seen.has(uid)) {
								seen.add(uid);
								ordered.push(uid);
							}
						});

					// Defensive: include any uid present in result but absent from DOM
					// (e.g. a tmp annotation not yet committed to the DOM).
					Object.getOwnPropertyNames(result).forEach((uid: string) => {
						if (!seen.has(uid)) {
							ordered.push(uid);
						}
					});

					return ordered;
				},
				getOwnPropertyDescriptor: (target: any, key: string) => {
					if (Object.prototype.hasOwnProperty.call(target, key)) {
						return {
							value: target[key],
							writable: true,
							enumerable: true,
							configurable: true,
						};
					}
					return undefined;
				},
			});
		};
	}

	/**
	 * Clamp long comment bodies in the Tiny Comments sidebar and add a
	 * SHOW MORE / SHOW LESS toggle. TinyMCE 6's comments plugin did this
	 * natively; v8 dropped it, so we re-create it via the public sidebar DOM
	 * (no minified-bundle patching, survives future upgrades).
	 */
	private installCommentReadMore(editor: any): void {
		const CLAMP = 96; // px (~4-5 lines) — tune to taste
		const doc: Document = editor.getContainer()?.ownerDocument || this.document;

		if (!doc.getElementById('tcrm-style')) {
			const style = doc.createElement('style');
			style.id = 'tcrm-style';
			style.textContent = `
				.tox-comment__body.tcrm-clamped { max-height: ${CLAMP}px; overflow: hidden; position: relative; }
				.tox-comment__body.tcrm-clamped::after { content:''; position:absolute; left:0; right:0; bottom:0;
					height:28px; background:linear-gradient(rgba(255,255,255,0), #fff); pointer-events:none; }
				.tcrm-toggle { display:inline-block; margin:2px 0 6px; background:none; border:none; padding:0;
					color:#4a72ff; font-weight:600; font-size:11px; letter-spacing:.04em; cursor:pointer; text-transform:uppercase; }
			`;
			doc.head.appendChild(style);
		}

		const TOGGLE = 'tcrm-toggle';
		const BODY = 'tox-comment__body';

		// Does this body overflow the clamp? Measured against the *unclamped*
		// height so an already-collapsed body reports its true size.
		const overflows = (body: HTMLElement): boolean => {
			// Skip bodies that aren't laid out yet (detached, hidden, or
			// mid-animation at zero width). Measuring scrollHeight then would
			// inflate it — a freshly added comment sliding in at a narrow width
			// wraps to many lines and falsely looks long.
			if (!body.isConnected || body.clientWidth === 0) {
				return false;
			}
			const wasClamped = body.classList.contains('tcrm-clamped');
			if (wasClamped) {
				body.classList.remove('tcrm-clamped');
			}
			const tooTall = body.scrollHeight > CLAMP + 8;
			if (wasClamped) {
				body.classList.add('tcrm-clamped');
			}
			return tooTall;
		};

		// Source of truth for collapse/expand is the body's `tcrmState` data
		// attribute, NOT the clamp class. On re-render TinyMCE rewrites the body's
		// className (wiping our clamp class) while keeping the element — so the
		// class can't be trusted, but the data attribute survives. applyState
		// re-derives the class + label from that intent on every scan.
		const applyState = (body: HTMLElement, btn: HTMLElement) => {
			const open = body.dataset.tcrmState === 'open';
			body.classList.toggle('tcrm-clamped', !open);
			btn.textContent = open ? 'SHOW LESS' : 'SHOW MORE';
		};

		// The toggle resolves its body from the DOM (previous sibling) at click
		// time — never a captured reference — so it keeps working even after
		// TinyMCE recreates the comment card around it.
		const makeToggle = (): HTMLButtonElement => {
			const btn = doc.createElement('button');
			btn.type = 'button';
			btn.className = TOGGLE;
			btn.textContent = 'SHOW MORE';
			btn.addEventListener('click', () => {
				const body = btn.previousElementSibling as HTMLElement | null;
				if (!body || !body.classList.contains(BODY)) {
					return;
				}
				body.dataset.tcrmState =
					body.dataset.tcrmState === 'open' ? 'closed' : 'open';
				applyState(body, btn);
			});
			return btn;
		};

		// Idempotent reconcile: bring the DOM to the desired state regardless of
		// how many times TinyMCE re-renders. No per-element flags, so recreated
		// bodies can't accumulate duplicate toggles.
		const scan = () => {
			// 1) Drop orphaned toggles (their body was removed/replaced). This is
			//    what produced the stray "SHOW MORE" below the composer.
			doc.querySelectorAll('.' + TOGGLE).forEach((el: Element) => {
				const prev = el.previousElementSibling;
				if (!prev || !prev.classList.contains(BODY)) {
					el.remove();
				}
			});

			// 2) Each comment body gets exactly one toggle iff it overflows.
			doc.querySelectorAll('.' + BODY).forEach((el: Element) => {
				const body = el as HTMLElement;
				const next = body.nextElementSibling as HTMLElement | null;
				const existing = next && next.classList.contains(TOGGLE) ? next : null;

				// The edit/reply input form reuses the `.tox-comment__body` class
				// for its wrapper, but that wrapper holds a <textarea> (plus
				// Save/Cancel) instead of rendered text. Clamping an input box and
				// hanging a SHOW MORE off it is wrong — detect it by the textarea it
				// contains and skip. A displayed comment never holds a <textarea>,
				// so real comments (including siblings in a thread) are unaffected.
				if (body.querySelector('textarea')) {
					body.classList.remove('tcrm-clamped');
					existing?.remove();
					return;
				}

				if (overflows(body)) {
					// Default new/recreated bodies (no stored intent) to collapsed;
					// a tap sets 'open'. Either way applyState re-asserts the clamp
					// class from that intent every scan, so a TinyMCE className wipe
					// during an edit can't silently leave the comment expanded.
					if (!body.dataset.tcrmState) {
						body.dataset.tcrmState = 'closed';
					}
					let btn = existing;
					if (!btn) {
						btn = makeToggle();
						body.insertAdjacentElement('afterend', btn);
					}
					applyState(body, btn);
				} else {
					body.classList.remove('tcrm-clamped');
					delete body.dataset.tcrmState;
					existing?.remove();
				}
			});
		};

		const target = editor.getContainer() || doc.body;
		const view = doc.defaultView || window;

		// Run scan() with the observer paused so our own toggle writes can't
		// re-trigger it (takeRecords discards the records they generate).
		const runScan = () => {
			const observer = this.commentReadMoreObserver;
			if (!observer) {
				return;
			}
			observer.disconnect();
			scan();
			observer.takeRecords();
			observer.observe(target, { childList: true, subtree: true });
		};

		// Coalesce bursts of mutations into a single scan per frame. TinyMCE
		// emits thousands of DOM changes during init/typing; running scan() (which
		// forces a reflow per body) on each one is what blew up memory and hung
		// the page.
		this.commentReadMoreObserver?.disconnect();
		this.commentReadMoreObserver = new MutationObserver(() => {
			if (this.commentReadMoreFrame == null) {
				this.commentReadMoreFrame = view.requestAnimationFrame(() => {
					this.commentReadMoreFrame = undefined;
					runScan();
				});
			}
			// Trailing pass once mutations stop, so a body measured mid-render or
			// mid-animation (e.g. a new comment sliding in) is re-evaluated after
			// layout settles. scan() is idempotent, so a now-short body drops its
			// stray toggle here.
			if (this.commentReadMoreTimer != null) {
				view.clearTimeout(this.commentReadMoreTimer);
			}
			this.commentReadMoreTimer = view.setTimeout(() => {
				this.commentReadMoreTimer = undefined;
				runScan();
			}, 350);
		});
		this.commentReadMoreObserver.observe(target, {
			childList: true,
			subtree: true,
		});
		scan();
	}

	public ngOnInit() {
		this.assignmentService.loadProfile().subscribe(data => {
			this.currentUser = {
				email: data.email,
				displayName: `${data.firstName} ${data.lastName}`,
				multimedia: data.multimedia,
			};
		});
		this.contentChanged$.pipe(debounceTime(3000)).subscribe(() => {
			this.lastUpdated.emit();
			this.onUpdate();
			this.isAutoSaveInProgress = true;
		});

		const extendObj: any = {
			tinycomments_create: this.tinycomments_create,
			tinycomments_reply: this.tinycomments_reply,
			tinycomments_edit_comment: this.tinycomments_edit_comment,
			tinycomments_delete: this.tinycomments_delete,
			tinycomments_delete_all: this.tinycomments_delete_all,
			tinycomments_delete_comment: this.tinycomments_delete_comment,
			tinycomments_lookup: this.tinycomments_lookup,
			images_upload_handler: this.example_image_upload_handler,
		};

		if (this.readOnly) {
			extendObj.readonly = true;

			extendObj.tinycomments_access = 'comment';

			extendObj.setup = (editor: any) => {
				// Show a floating "Add comment" button when text is selected, so the
				// reviewer doesn't have to reach for the toolbar "+" button. Uses the
				// core context-toolbar API (works in readonly; no quickbars plugin needed).
				editor.ui.registry.addContextToolbar('selectioncomment', {
					predicate: () => !editor.selection.isCollapsed(),
					items: 'addcomment',
					position: 'selection',
					scope: 'node',
				});
				editor.on('init', () => {
					// Give the icon-only built-in "addcomment" button a visible
					// "Add Comment" label (preserving its native action) so the
					// selection popup is self-explanatory.
					const addComment = editor.ui.registry.getAll().buttons.addcomment;
					if (addComment) {
						editor.ui.registry.addButton('addcomment', {
							...addComment,
							text: 'Add Comment',
						});
					}
					// allow comment commands in readonly mode
					editor.mode.set('readonly');
				});
			};

			extendObj.init_instance_callback = editor => {
				// editor.getBody().setAttribute('contenteditable', false);
				// Collapse long comment bodies with a SHOW MORE / SHOW LESS toggle
				// (v8's comments plugin dropped the v6 built-in expander).
				this.installCommentReadMore(editor);
				// Sort sidebar conversations by document position (not database ID).
				this.installDocumentOrderAnnotator(editor);
				editor.on('CommentChange', evt => {
					this.assignmentService
						.saveHtml(this.submissionId, {
							content: editor.getBody().innerHTML,
							fileUrls: this.files.map(obj => obj.fileUrl),
						})
						.subscribe(() => {});
				});

				editor.getBody().addEventListener(
					'click',
					event => {
						if (event.target.tagName === 'A') {
							if (event.target.href.search('http') === -1) {
								window.open(`https://${event.target.href}`, '_blank');
							} else {
								window.open(event.target.href, '_blank');
							}
							event.preventDefault();
						}
					},
					true,
				);

				editor.getBody().addEventListener(
					'focusout',
					event => {
						console.log(event);
					},
					true,
				);

				editor.on('ObjectSelected', e => {
					console.log(`The ${e} command was fired.`);
				});

				editor.on('BeforeObjectSelected', e => {
					console.log(`The ${e} command was fired.`);
				});

				editor.getBody().onkeydown = function (evt) {
					if (evt.which === 13 || evt.which === 8 || evt.which === 46) {
						alert('You modified the base doc. Reloading...');
						evt.preventDefault();
						evt.stopPropagation();
						location.reload();
						return false;
					}
				};

				// editor.getBody().addEventListener(
				// 	'keydown',
				// 	event => {
				// 		if (event.keyCode === 13) {
				// 			debugger;
				// 			event.preventDefault();
				// 			event.stopPropagation();
				// 			return false;
				// 		}
				// 	},
				// 	false,
				// );
			};
			extendObj.tinycomments_can_resolve = (req, done, fail) => {
				done({
					canResolve: false,
				});
			};
		}
		this.assignmentService.loadProfile().subscribe(data => {
			const currentUser = {
				email: data.email,
				displayName: `${data.firstName} ${data.lastName}`,
				multimedia: data.multimedia,
			};

			this.init = {
				height: 700,
				plugins: this.readOnly
					? 'tinycomments'
					: 'image link table lists wordcount',
				toolbar: this.readOnly
					? 'showcomments'
					: 'blocks | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat preview  | insertfile image media pageembed  link  | a11ycheck ltr rtl',
				placeholder: 'Please enter minimum 10 characters.',
				sidebar_show: 'showcomments',
				menubar: '',
				...extendObj,
				paste_preprocess: function (plugin, args) {
					args.content = args.content.replace(
						/<span[^>]*class="[^"]*mce-annotation[^"]*"[^>]*>(.*?)<\/span>/gi,
						'$1',
					);
				},

				user_id: currentUser ? currentUser.email : 'unknown',
				fetch_users: async () => {
					return [
						{
							id: currentUser ? currentUser.email : 'unknown',
							name: currentUser ? currentUser.displayName : 'Unknown User',
							avatar: currentUser ? currentUser.multimedia : null,
						},
					];
				},
			};
		});

		this.assignmentService.loadHtml(this.submissionId).subscribe(data => {
			this.content = data.content;
			this.files = data.assignmentUploads;
			this.assignmentId = data.assignmentId;
			this.cohortId = data.cohortId;
			localStorage.setItem('assignmentId', this.assignmentId);
		});
	}
	autoSave(content: any) {
		this.contentChanged$.next();
	}
	public onUpdate() {
		this.rudderStack.log({
			type: 'assignment_save_draft',
			cohortId: this.cohortId,
			submissionId: this.submissionId,
		});

		this.assignmentService
			.saveHtml(this.submissionId, {
				content: this.content,
				fileUrls: this.files.map(obj => obj.fileUrl),
			})
			.subscribe((req: any) => {
				if (!this.isAutoSaveInProgress) {
					this.authService.addToastMsg(req.message);
				}
				this.isAutoSaveInProgress = false;
			});
	}

	public showMsg(req) {
		if (req.error || req.count === 0) {
			this.editor.editor.notificationManager.open({
				text: req.message,
				type: 'error',
				timeout: 3000,
			});
		} else {
			this.editor.editor.notificationManager.open({
				text: req.message,
				type: 'success',
				timeout: 3000,
			});
		}
	}

	public onSubmit() {
		console.log(this.files);
		this.rudderStack.log({
			type: 'assignment_submitted',
			cohortId: this.cohortId,
			submissionId: this.submissionId,
		});

		if (this.content.length < 10) {
			this.authService.addToastMsg('Please enter minimum 10 characters.');
			return false;
		}
		this.assignmentService
			.saveHtml(this.submissionId, {
				content: this.content,
				fileUrls: this.files.map(obj => obj.fileUrl),
			})
			.subscribe((data: any) => {
				if (data.message) {
					this.assignmentService
						.saveAssignment(
							this.currentUser.email,
							this.submissionId,
							this.files,
						)
						.subscribe(response => {
							if (response) {
								this.learningService.editState(
									'assignment',
									this.cohortId,
									this.assignmentId,
									'id',
									'assignmentStatus',
									'Completed',
								);
								this.reloadData.emit();
							}
						});
				}
			});
	}

	public async attachFileInput(event) {
		this.rudderStack.log({
			type: 'assignment_upload_file',
			cohortId: this.cohortId,
			submissionId: this.submissionId,
		});

		const selectedFile = event.target.files[0] as File;

		if (!!selectedFile) {
			if (selectedFile.size > 10485760) {
				this.authService.addToastMsg(
					'Oops! The size limit for documents is 10 MB. Reduce the file size and try again.',
				);
				return false;
			}

			const formData: FormData = new FormData();
			formData.append('file', selectedFile);
			formData.append(
				'tags',
				this.rudderStack.currentProfileId +
					'_' +
					this.cohortId +
					'_' +
					this.submissionId +
					'_' +
					this.assignmentId,
			);
			formData.append('upload_preset', 'tugadh68');

			const token = await firebase.auth()?.currentUser?.getIdToken();

			this.http
				.post<any>(`${environment.url.profile}/upload/assignment`, formData, {
					reportProgress: true,
					headers: new HttpHeaders({
						Authorization: 'Bearer ' + token,
					}),
					observe: 'events',
				})
				.pipe(
					catchError(errors => {
						const { status, message, error } = errors;

						const errorMsg = `Error Code: ${status},  Message: ${message}`;

						this.editor.editor.notificationManager.open({
							text:
								'File format not supported. Please try a different file type.',
							type: 'success',
							timeout: 10000,
						});

						throw error;
					}),
				)
				.subscribe((event: any) => {
					if (HttpEventType.UploadProgress === event.type) {
						this.editor.editor.notificationManager.open({
							text:
								'Uploading Process ' +
								Math.round((event.loaded * 100) / event.total),
							type: 'success',
							timeout: 1000,
						});
					} else if (HttpEventType.DownloadProgress === event.type) {
						this.editor.editor.notificationManager.open({
							text: 'Uploading Done',
							type: 'success',
							timeout: 1000,
						});
					} else if (HttpEventType.Response === event.type) {
						const url = event.body.url;

						this.files.push({ fileUrl: url });
						this.assignmentService
							.saveHtml(this.submissionId, {
								content: this.content,
								fileUrls: this.files.map(obj => obj.fileUrl),
							})
							.subscribe((req: any) => {
								this.authService.addToastMsg(req.message);
							});
					}
				});
		}
	}
	public removeItem(item: string) {
		const index = this.files.indexOf(item);
		if (index !== -1) {
			this.files.splice(index, 1);
		}
		this.assignmentService
			.saveHtml(this.submissionId, {
				content: this.content,
				fileUrls: this.files.map(obj => obj.fileUrl),
			})
			.subscribe((req: any) => {
				this.authService.addToastMsg(req.message);
			});
	}
	public openNewTab(url: any) {
		window.open(url, '_blank');
	}
	public getTrimmedUrl(fullUrl: any) {
		const startIndex = fullUrl.indexOf('.com/') + 5;
		return fullUrl.substring(startIndex);
	}
}
